import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { KTCookie } from "../../_metronic/_assets/js/components/cookie";
import Homepage from "../modules/Homepage/pages/Homepage";


export function FrontPage() {

  const search = useLocation().search;
  const params = new URLSearchParams(search);  

  useEffect(() => {    
    const utm_source = params.get("utm_source");

    if (utm_source === 'takhfifan') {
      const tatoken = params.get("tatoken");
      setCookie(tatoken);
    }
  })

  const setCookie = (tatoken) => {
    if (!KTCookie.getCookie('takhfifan')) {
      var expires = new Date(new Date().getTime() + 30 * 24 * 60 * 60 * 1000); // expire in 15 minutes from now
      KTCookie.setCookie("takhfifan", tatoken, { expires: expires })
      console.log("takhfifan cooki set")
    }
  }
  
  return <Homepage />;
}
